import React, { useEffect, useRef, useState } from 'react';
import './VideoIntro.css';

const VideoIntro = ({ onVideoEnd }) => {
  const videoRef = useRef(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleLoadedData = () => {
      setIsVideoLoaded(true);
    };

    const handleError = () => {
      setHasError(true);
      // Si hay error, pasar directamente al login después de 2 segundos
      setTimeout(() => {
        onVideoEnd();
      }, 2000);
    };

    const handleEnded = () => {
      onVideoEnd();
    };

    video.addEventListener('loadeddata', handleLoadedData);
    video.addEventListener('error', handleError);
    video.addEventListener('ended', handleEnded);

    // Intentar reproducir automáticamente
    video.play().catch(() => {
      // Si autoplay falla, mostrar controles
      console.log('Autoplay falló, mostrando controles'); // eslint-disable-line no-console
    });

    return () => {
      video.removeEventListener('loadeddata', handleLoadedData);
      video.removeEventListener('error', handleError);
      video.removeEventListener('ended', handleEnded);
    };
  }, [onVideoEnd]);

  const handleSkip = () => {
    onVideoEnd();
  };

  return (
    <div className="video-intro">
      <video
        ref={videoRef}
        className="intro-video"
        autoPlay
        muted
        playsInline
        preload="metadata"
        disablePictureInPicture
        controls={false}
      >
        <source src="/video_landing.mp4" type="video/mp4" />
        Tu navegador no soporta el elemento de video.
      </video>

      {/* Overlay con controles */}
      <div className="video-overlay">
        <div className="video-controls">
          <button
            className="skip-button"
            onClick={handleSkip}
            aria-label="Saltar video introductorio"
          >
            <i className="fas fa-times"></i>
            Saltar
          </button>
        </div>

        {/* Indicador de carga */}
        {!isVideoLoaded && !hasError && (
          <div className="loading-indicator">
            <div className="loading-spinner"></div>
            <p>Cargando video...</p>
          </div>
        )}

        {/* Mensaje de error */}
        {hasError && (
          <div className="error-indicator">
            <i className="fas fa-exclamation-triangle"></i>
            <p>No se pudo cargar el video</p>
            <p className="error-subtitle">Continuando al login...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoIntro;